import React from 'react';
import Layout from '../../components/Layout';
import Card from '../../components/Card';
import '../../styles/components.css';

const TRFGuidelines = () => {
    return (
        <Layout title="TRF Guidelines">
            <Card title="Thiagarajar Research Fellowship (TRF) - Guidelines & Information">

                {/* Objectives */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        📌 Objectives
                    </h2>
                    <ul style={{ lineHeight: '1.8', color: '#4b5563' }}>
                        <li>To increase the number of full-time research scholars</li>
                        <li>To enhance number of quality publications</li>
                    </ul>
                </section>

                {/* Eligibility */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        ✅ Eligibility for TRF
                    </h2>
                    <div style={{ background: '#eff6ff', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #3b82f6' }}>
                        <ul style={{ lineHeight: '1.8', color: '#1e40af', margin: 0 }}>
                            <li>The TRF will be granted to the <strong>full-time research scholars of TCE</strong> admitted under Anna University, Chennai</li>
                            <li>Applicants must possess <strong>First Class in either bachelor or master degrees</strong></li>
                            <li>Applicants must <strong>not receive any other Research Fellowship</strong></li>
                        </ul>
                    </div>
                </section>

                {/* Duration */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        ⏱️ Duration of Fellowship
                    </h2>
                    <p style={{ fontSize: '1.125rem', color: '#4b5563', fontWeight: '600' }}>
                        Maximum of <span style={{ color: '#3b82f6' }}>3 years</span>
                    </p>
                </section>

                {/* Fellowship Amount */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        💰 Amount of Fellowship
                    </h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
                        <div style={{ background: '#dcfce7', padding: '1.5rem', borderRadius: '0.5rem', textAlign: 'center', border: '2px solid #16a34a' }}>
                            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#15803d' }}>₹15,000</div>
                            <div style={{ color: '#15803d', marginTop: '0.5rem' }}>per month</div>
                            <div style={{ fontSize: '0.875rem', color: '#15803d', marginTop: '0.25rem', fontWeight: '600' }}>First Year</div>
                        </div>
                        <div style={{ background: '#dbeafe', padding: '1.5rem', borderRadius: '0.5rem', textAlign: 'center', border: '2px solid #2563eb' }}>
                            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1e40af' }}>₹20,000</div>
                            <div style={{ color: '#1e40af', marginTop: '0.5rem' }}>per month</div>
                            <div style={{ fontSize: '0.875rem', color: '#1e40af', marginTop: '0.25rem', fontWeight: '600' }}>Second Year</div>
                        </div>
                        <div style={{ background: '#fef3c7', padding: '1.5rem', borderRadius: '0.5rem', textAlign: 'center', border: '2px solid #f59e0b' }}>
                            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#92400e' }}>₹25,000</div>
                            <div style={{ color: '#92400e', marginTop: '0.5rem' }}>per month</div>
                            <div style={{ fontSize: '0.875rem', color: '#92400e', marginTop: '0.25rem', fontWeight: '600' }}>Third Year</div>
                        </div>
                    </div>
                </section>

                {/* Expected Outcomes */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        🎯 Expected Outcomes During TRF Period
                    </h2>

                    <div style={{ background: '#f9fafb', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem' }}>
                        <h3 style={{ color: '#374151', marginBottom: '0.75rem' }}>📅 At the end of 6 months:</h3>
                        <ul style={{ color: '#4b5563', lineHeight: '1.8' }}>
                            <li>A paper <strong>submitted</strong> to conference (Scopus Indexed) at least one month prior to review meeting</li>
                        </ul>
                    </div>

                    <div style={{ background: '#f9fafb', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem' }}>
                        <h3 style={{ color: '#374151', marginBottom: '0.75rem' }}>📅 At the end of 1 year:</h3>
                        <ul style={{ color: '#4b5563', lineHeight: '1.8' }}>
                            <li>At least <strong>one publication</strong> in reputed conference (Scopus Indexed) with DOI</li>
                            <li>A paper <strong>communicated</strong> to refereed journal (Q1/Q2/Q3) at least one month prior to review</li>
                        </ul>
                    </div>

                    <div style={{ background: '#f9fafb', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem' }}>
                        <h3 style={{ color: '#374151', marginBottom: '0.75rem' }}>📅 At the end of 1.5 years:</h3>
                        <ul style={{ color: '#4b5563', lineHeight: '1.8' }}>
                            <li>At least <strong>one conference</strong> publication (Scopus Indexed) with DOI</li>
                            <li>At least <strong>one paper accepted</strong> in journal (Q1/Q2/Q3)</li>
                            <li>A paper submitted to conference (Scopus Indexed)</li>
                        </ul>
                    </div>

                    <div style={{ background: '#f9fafb', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem' }}>
                        <h3 style={{ color: '#374151', marginBottom: '0.75rem' }}>📅 At the end of 2 years:</h3>
                        <ul style={{ color: '#4b5563', lineHeight: '1.8' }}>
                            <li>At least <strong>two conference</strong> publications (Scopus Indexed) with DOI</li>
                            <li>At least <strong>one journal</strong> publication (Q1/Q2/Q3)</li>
                            <li>Papers submitted to conference and communicated to journal</li>
                        </ul>
                    </div>

                    <div style={{ background: '#f9fafb', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem' }}>
                        <h3 style={{ color: '#374151', marginBottom: '0.75rem' }}>📅 At the end of 2.5 years:</h3>
                        <ul style={{ color: '#4b5563', lineHeight: '1.8' }}>
                            <li>At least <strong>three conference</strong> publications (Scopus Indexed) with DOI</li>
                            <li>At least <strong>two journal</strong> publications (Q1/Q2/Q3)</li>
                            <li>A paper communicated to journal (Q1/Q2/Q3)</li>
                        </ul>
                    </div>

                    <div style={{ background: '#dcfce7', padding: '1rem', borderRadius: '0.5rem', border: '2px solid #16a34a' }}>
                        <h3 style={{ color: '#15803d', marginBottom: '0.75rem' }}>📅 At the end of 3 years (Final):</h3>
                        <ul style={{ color: '#15803d', lineHeight: '1.8', fontWeight: '600' }}>
                            <li>At least <strong>three conference</strong> publications (Scopus Indexed) with DOI</li>
                            <li>At least <strong>three journal</strong> publications (Q1/Q2/Q3)</li>
                        </ul>
                    </div>

                    <div style={{ background: '#fef3c7', padding: '1rem', borderRadius: '0.5rem', marginTop: '1rem', border: '1px solid #f59e0b' }}>
                        <h4 style={{ color: '#92400e', marginBottom: '0.5rem' }}>⚠️ Important Notes:</h4>
                        <ul style={{ color: '#92400e', fontSize: '0.875rem', lineHeight: '1.6', margin: 0 }}>
                            <li>Only <strong>four authors</strong> are allowed (inclusive of scholar and supervisor)</li>
                            <li>Either scholar or supervisor must be a <strong>corresponding author</strong></li>
                            <li>TRF funding must be <strong>acknowledged</strong> in all publications</li>
                            <li>Conference publications must be <strong>indexed in Scopus</strong> (within a year)</li>
                            <li>Conference publications included as book chapters will <strong>not be considered</strong></li>
                            <li>Publications without TRF Acknowledgement will <strong>not be considered</strong></li>
                        </ul>
                    </div>
                </section>

                {/* TRF Acknowledgement */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        📝 TRF Acknowledgement Format
                    </h2>
                    <div style={{ background: '#1f2937', color: '#fff', padding: '1rem', borderRadius: '0.5rem', fontFamily: 'monospace', fontSize: '0.875rem' }}>
                        "This research work is financially supported by Thiagarajar Research Fellowship (TRF) scheme - (File.no: TCE/RD/TRF/[NUMBER] dated [DATE])"
                    </div>
                    <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#dc2626', fontWeight: '600' }}>
                        ⚠️ This acknowledgement is MANDATORY in all publications
                    </p>
                </section>

                {/* Suspension */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        ⏸️ Suspension of Fellowship
                    </h2>
                    <div style={{ background: '#fee2e2', padding: '1rem', borderRadius: '0.5rem', border: '1px solid #dc2626' }}>
                        <ul style={{ color: '#991b1b', lineHeight: '1.8', margin: 0 }}>
                            <li>Scholars who do not satisfy the outcome requirements will have their fellowships <strong>suspended</strong></li>
                            <li>The minimum period of suspension is <strong>one month</strong></li>
                        </ul>
                    </div>
                </section>

                {/* Cancellation */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        ❌ Cancellation of Fellowship
                    </h2>
                    <div style={{ background: '#fee2e2', padding: '1rem', borderRadius: '0.5rem', border: '2px solid #dc2626' }}>
                        <ul style={{ color: '#991b1b', lineHeight: '1.8', margin: 0 }}>
                            <li>Unsatisfactory progress of research work or failure in course work</li>
                            <li>Any false information furnished by the scholar or fraudulent activity</li>
                            <li>The fellowship may be terminated at any time and the decision of TCE will be <strong>final and binding</strong></li>
                            <li>Violation of TRF Guidelines</li>
                        </ul>
                    </div>
                </section>

                {/* Scholar Guidelines */}
                <section style={{ marginBottom: '2rem' }}>
                    <h2 style={{ color: '#1f2937', borderBottom: '2px solid #3b82f6', paddingBottom: '0.5rem', marginBottom: '1rem' }}>
                        📋 Guidelines for TRF Scholars
                    </h2>
                    <ol style={{ color: '#4b5563', lineHeight: '1.8' }}>
                        <li>The scholar must devote <strong>full time to research</strong> and will not be permitted to take any part-time/full-time assignment</li>
                        <li>The scholar will not accept any salary, fellowship or financial assistance from any other source</li>
                        <li>Commercial exploitation and patent rights will be with the Institute, candidate and supervisor</li>
                        <li>If progress is reported as unsatisfactory, the fellowship will be <strong>terminated immediately</strong></li>
                        <li>Ph.D. rules and regulations of TCE and Anna University will be applicable</li>
                        <li>No separate medical assistance will be provided (may avail TCE medical facilities)</li>
                        <li>Accommodation, contingencies and other expenses will not be given separately</li>
                        <li>Leave details are as per TCE norms</li>
                        <li>Teaching assistantship of <strong>not more than 8 hours/week</strong> may be assigned</li>
                        <li>If leaving before completion, scholar must <strong>refund the entire fellowship amount</strong></li>
                        <li>Progress will be monitored by review committee every six months</li>
                        <li>TRF fellows will be given opportunity to apply for faculty posts within TCE</li>
                    </ol>
                </section>

                {/* Special Note */}
                <section>
                    <div style={{ background: '#dcfce7', padding: '1.5rem', borderRadius: '0.5rem', border: '2px solid #16a34a' }}>
                        <h3 style={{ color: '#15803d', marginBottom: '0.75rem' }}>🎓 Special Provision</h3>
                        <p style={{ color: '#15803d', margin: 0, lineHeight: '1.6' }}>
                            If a TRF fellow is selected and joins as a faculty in TCE, <strong>they will not be required to repay the TRF stipend</strong>.
                        </p>
                    </div>
                </section>

            </Card>
        </Layout>
    );
};

export default TRFGuidelines;
